import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

import { wsGetAll } from 'services/WService';
import Modal from 'components/Tvendo/Common/ModalBase';

export default function ModalSaleForceDetail(props) {
  const saleForceDetail = props.model;

  const [dataChanging, setDataChanging] = useState(saleForceDetail);

  const [sellers, setSellers] = useState([]);
  const [canals, setCanals] = useState([]);

  async function listSellers() {
    let response = await wsGetAll('base/seller');
    if (response.success) setSellers(response.data);
  }

  async function listCanals() {
    let response = await wsGetAll('base/canal');
    if (response.success) setCanals(response.data);
  }

  function handleChange(field, value) {
    setDataChanging({
      ...dataChanging,
      [field]: value
    });
  }

  useEffect(() => {
    if (saleForceDetail.open) {
      listSellers();
      listCanals();
    }
  }, [saleForceDetail.open]);

  return (
    <Modal
      title="Detalle Fuerza de venta"
      model={saleForceDetail}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity="base/sale-force-detail"
      dataForce={{ base_sale_force_id: props.idSaleForce }}
      state
    >
      {sellers.length > 0 ? (
        <Autocomplete
          options={sellers}
          getOptionLabel={(option) => option.SlpName}
          defaultValue={
            !!saleForceDetail
              ? sellers.find((item) => item.id == saleForceDetail.base_seller_id)
              : undefined
          }
          renderInput={(params) => (
            <TextField {...params} label="Vendedor" margin="normal" required />
          )}
          onChange={(e, item) => {
            if (!!item) {
              return handleChange('base_seller_id', item.id);
            }
            handleChange('base_seller_id', null);
          }}
        />
      ) : undefined}

      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Canal</InputLabel>
        <Select
          defaultValue={saleForceDetail.base_canal_id || ''}
          inputProps={{
            name: 'base_canal_id'
          }}
        >
          {canals.map((canal, i) => {
            return (
              <MenuItem value={canal.id} key={i}>
                {canal.description}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Modal>
  );
}
